import { BarChart3, ListChecks } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../../lib/utils.js';

/**
 * Segmented toggle between Value Metrics + Scenario KPIs.
 * Mirrors the legacy two-button pill control in `sec_215` (Value
 * Metrics | Scenario KPIs). Each side is a NavLink so it gets
 * "active" styling automatically based on the URL — no internal
 * state, no router push from a controlled component.
 */
export function ValuePagesToggle(): JSX.Element {
  return (
    <nav className="inline-flex items-center gap-1.5 rounded-md border border-foreground/15 bg-foreground/[0.04] p-1">
      <NavLink
        to="/value"
        end
        className={({ isActive }) =>
          cn(
            'flex items-center gap-1.5 rounded px-3 py-1 text-sm transition-colors',
            isActive
              ? 'bg-foreground/15 text-foreground'
              : 'text-foreground/70 hover:text-foreground',
          )
        }
      >
        <BarChart3 className="h-3.5 w-3.5" />
        <span>Value Metrics</span>
      </NavLink>
      <NavLink
        to="/value/scenario-kpis"
        className={({ isActive }) =>
          cn(
            'flex items-center gap-1.5 rounded px-3 py-1 text-sm transition-colors',
            isActive
              ? 'bg-foreground/15 text-foreground'
              : 'text-foreground/70 hover:text-foreground',
          )
        }
      >
        <ListChecks className="h-3.5 w-3.5" />
        <span>Scenario KPIs</span>
      </NavLink>
    </nav>
  );
}
